export function isMarketplacePlace(place) {
  return Boolean(place?.place_is_marketplace);
}
